import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { SpinnerFullPage } from "src/core/components/custom-ui/spinner-full-page";
import { ROUTE_PATH } from "src/core/constants/routePath";
import { useTenant } from "src/core/contexts/TenantContext/TenantProvider";

/**
 * TenantsValidationGate :
 * Rôle fonctionnel :
 * - Attendre la validation / récupération de la liste des tenants accessibles
 *   pour l'utilisateur authentifié.
 * - Centraliser le cas où l'utilisateur est bien authentifié mais n'a accès à AUCUN tenant.
 *
 * Ce composant ne dépend pas de l'URL (pas de :tenantId ici).
 * Il sert de prérequis global avant toute logique "tenant-scoped".
 */
export const TenantsValidationGate: FC = () => {
  const { isValidatingTenants, availableTenants } = useTenant();

  if (isValidatingTenants) {
    return <SpinnerFullPage />;
  }

  /**
   * Cas utilisateur authentifié MAIS sans aucun tenant accessible.
   *
   * Exemple :
   * - Compte valide
   * - Droits absents ou retirés
   * - Backend renvoie 200 avec une liste vide
   * - Token sans tenants
   *
   * On centralise ici la décision métier :
   * => accès interdit à l'application.
   */
  if (availableTenants.length === 0) {
    console.warn("[NAV] TenantsValidationGate -> ERROR_403 (no tenant access)");
    return <Navigate to={ROUTE_PATH.ERROR_403} replace />;
  }

  return <Outlet />;
};
